import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';

import type { RoomResponse } from 'app/typings/core/admin/rooms/room';
import type { CreateRoomRequest } from 'app/typings/core/admin/rooms/roomForm';
import { apiMutation } from 'app/utils/request/api';

import { CORE_QUERY_KEYS, ENDPOINTS } from '.';

export function useCreateRoom() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: CreateRoomRequest) =>
      apiMutation(
        'POST',
        { path: ENDPOINTS.createRoom },
        payload
      ) as Promise<RoomResponse>,
    onSuccess: (response) => {
      message.success('Room successfully created');

      queryClient.invalidateQueries({
        queryKey: [CORE_QUERY_KEYS.rooms],
      });

      queryClient.setQueryData(
        [CORE_QUERY_KEYS.room, { id: response.id.toString() }],
        response
      );
    },
    onError: () => {
      message.error('Failed to create room');
    },
  });
}
